var BraintreeHostedFields = (function (braintree, $) {

	var BraintreeHostedFields = function (opts) {
		this.$created = new $.Deferred();
		this.instance = null;
		this.fieldErrorClass = '';
		this.stylesOptions = {};
		this.fieldsOptions = {};
		$.extend(this, opts);
	};

	$.extend(BraintreeHostedFields.prototype, {
		init: function (clientInstance) {
			var callback = $.proxy(this._callback, this, clientInstance);

			braintree.hostedFields.create({
				client: clientInstance,
				styles: this.stylesOptions,
				fields: this.fieldsOptions
			}, callback);

			return this.$created.promise();
		},
		_callback: function (clientInstance, createErr, instance) {
			if (!createErr) this.instance = instance;

			instance.on('validityChange', $.proxy(function (event) {
				this._isValid(this._getField(event));
			}, this));

			instance.on('blur', $.proxy(function (event) {
				this._isValid(this._getField(event));
			}, this));

			instance.on('focus', $.proxy(function (event) {
				this._toggleFieldState(this._getField(event), true);
			}, this));

			this.$created.resolve(clientInstance);
		},
		_getField: function (event) {
			return event.fields[event.emittedBy];
		},
		_isValid: function (field, checkIsEmpty) {
			var isValid = checkIsEmpty ? !field.isEmpty : true;
			isValid = isValid && !$(field.container).hasClass(this.fieldErrorClass);
			//isValid = isValid && field.isPotentiallyValid;
			//isValid = isValid && field.isValid;
			this._toggleFieldState(field, isValid);
			return isValid;
		},
		_toggleFieldState: function (field, isValid) {
			$(field.container).toggleClass(this.fieldErrorClass, !isValid);
			if (field.container.id) $('label[for=' + field.container.id + ']').toggleClass(this.fieldErrorClass, !isValid);
		},
		getPayload: function () {
			var $result = new $.Deferred();
			var isValid = this.isValid();
			var fields = this.instance.getState().fields;
			var toggleFieldState = $.proxy(this._toggleFieldState, this);
			if (!isValid) return $result.reject().promise();

			this.instance.tokenize(function (err, payload) {
				if (err) {
					switch (err.code) {
						case 'HOSTED_FIELDS_FIELDS_EMPTY':
							$.each(fields, $.proxy(function (key, field) {
								toggleFieldState(field, false);
							}, this));
							break;
						case 'HOSTED_FIELDS_FIELDS_INVALID':
							$.each(err.details.invalidFieldKeys, $.proxy(function (index, key) {
								toggleFieldState(fields[key], false);
							}, this));
							break;
					}
					$result.reject({ error: err });
				} else {
					$result.resolve({
						Nonce: payload.nonce,
						Bin: payload.details.bin,
						Type: 'braintree',
						isNew: true
					});
				}
			});
			return $result.promise();
		},
		isValid: function () {
			var isValid = true;
			var fields = this.instance.getState().fields;
			$.each(fields, $.proxy(function (key, field) {
				isValid = this._isValid(field, true) && isValid;
			}, this));
			return isValid;
		},
        clearValidation: function() {
            var fields = this.instance.getState().fields;
            $.each(fields, $.proxy(function (key, field) {
                this._toggleFieldState(field, true);
            }, this));
        }
	});

	return BraintreeHostedFields;
})(window.braintree, jQuery);